import { ChangeEvent, FocusEvent } from "react";
import { InputAdornment, TableCell, TableRow } from "@mui/material";
import { StyledTextField } from "@stories/atoms/StyledTextField/StyledTextField";
import { TargetUnit } from "@interfaces/commitment";
import { StyledButton } from "@stories/atoms/StyledButton/StyledButton";
import { NumericFormatCustom } from "@stories/atoms/NumericFormatCustom/NumericFormatCustom";

interface SocialProcurementTableRowProps {
  loading: boolean;
  title: string;
  metric: TargetUnit;
  valueId: string;
  value: number;
  valueName: string;
  valueTouched?: boolean;
  valueError?: string;
  outcomeMultiplier: number;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onBlur: (e: FocusEvent<HTMLInputElement>) => void;
  onDelete: () => void;
}

export const SocialProcurementTableRow = ({
  loading,
  title,
  metric,
  valueId,
  valueName,
  value,
  valueTouched,
  valueError,
  outcomeMultiplier,
  onChange,
  onBlur,
  onDelete,
}: SocialProcurementTableRowProps) => {
  return (
    <TableRow key={title}>
      <TableCell align="left" sx={{ minWidth: "10vw" }}>
        {title}
      </TableCell>
      <TableCell align="center">
        <StyledTextField
          disabled={loading}
          id={valueId}
          name={valueName}
          fullWidth
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          error={valueTouched && Boolean(valueError)}
          helperText={valueTouched ? valueError : ""}
          InputProps={{
            inputComponent: NumericFormatCustom as any,
            endAdornment: <InputAdornment position="end">%</InputAdornment>,
          }}
        />
      </TableCell>
      <TableCell align="center" sx={{ minWidth: "10vw" }}>
        {metric === TargetUnit.Spend ? "$ " : null}
        {((outcomeMultiplier * value) / 100).toLocaleString()}
        {metric === TargetUnit.Hour ? " hours" : null}
      </TableCell>
      <TableCell align="center" sx={{ minWidth: "10vw" }}>
        <StyledButton
          onClick={() => {
            onDelete();
          }}
          color="error"
        >
          Remove
        </StyledButton>
      </TableCell>
    </TableRow>
  );
};
